import Raven from 'raven-js';
import enviro from 'enviro';
const TEST_SITE_KEY = '6Le6rD8kAAAAAFAKCOH96PLU8P5WE1RWz5Sz5Quh';
const PROD_SITE_KEY = '6LdZL7wkAAAAAJ8fv2_ZtTKDmr22AeNATST8naKi';
const GOOGLE_RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/enterprise.js';
const FALLBACK_SCRIPT_URL = 'https://recaptcha.net/recaptcha/enterprise.js';
export function addRecaptchaScript(isATPortal) {
  const isQA = enviro.isQa();
  const siteKey = isQA || isATPortal ? TEST_SITE_KEY : PROD_SITE_KEY;
  const script = createRecaptchaScript({
    src: GOOGLE_RECAPTCHA_SCRIPT_URL,
    siteKey,
    onError: () => {
      createRecaptchaScript({
        src: FALLBACK_SCRIPT_URL,
        siteKey,
        onError: e => {
          throw e;
        }
      });
    }
  });
  document.head.appendChild(script);
}
function createRecaptchaScript({
  src,
  siteKey,
  onError
}) {
  const script = document.createElement('script');
  script.async = true;
  script.type = 'text/javascript';
  script.src = `${src}?render=${siteKey}`;
  script.onerror = onError;
  return script;
}
export const getRecaptchaToken = (isATPortal, action) => {
  const isQA = enviro.isQa();
  const siteKey = isQA || isATPortal ? TEST_SITE_KEY : PROD_SITE_KEY;
  if (!window.grecaptcha) {
    Raven.captureMessage(`window.grecaptcha failed to load, submitting payment with null token`);
    return Promise.resolve(null);
  }
  return new Promise((resolve, reject) => {
    const rejectWithReport = err => {
      Raven.captureMessage(`The grecaptcha.enterprise.execute failed with error: ${err}`);
      reject(err);
    };
    window.grecaptcha.enterprise.ready(() => {
      try {
        window.grecaptcha.enterprise.execute(siteKey, {
          action
        }).then(resolve).catch(rejectWithReport);
      } catch (err) {
        rejectWithReport(err);
      }
    });
  });
};
export const getIsRecaptchaEnabled = ({
  liveMode,
  recaptchaIntegration
}) => Boolean(liveMode && (recaptchaIntegration === null || recaptchaIntegration === void 0 ? void 0 : recaptchaIntegration.isEnabled));